import React, { FC } from 'react';
import { IconProps } from '.';

export const DeleteIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    return (
        <svg fill="none" {...sizing} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                stroke="currentColor"
                strokeWidth="1.5"
                d="M5.88 8c-.02-.13.07-.25.22-.25h11.81c.16 0 .24.12.23.23a525.8 525.8 0 0 1-1.62 11.22c-.1.6-.62 1.05-1.23 1.05H8.72c-.62 0-1.14-.45-1.23-1.06-.43-2.87-1.27-8.6-1.61-11.2Z"
            />
            <path stroke="currentColor" d="M13.75 4.75a1.75 1.75 0 1 0-3.5 0" />
            <path stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" d="M5.5 5.25h13" />
            <mask id="cf0af55e" width="9" height="9" x="8" y="9" maskUnits="userSpaceOnUse">
                <path fill="#fff" d="M16.38 9.69H8.05v7.87h8.31V9.7Z" />
            </mask>
            <g mask="url(#cf0af55e)">
                <path fill="url(#b9a9cf51)" d="M12.44 8.9v13.47h-.88V8.9h.88Z" />
                <path stroke="url(#fe1ac347)" d="m15.06 8.9-.87 13.56" />
                <path stroke="url(#a5290a55)" d="m8.94 8.9.87 13.56" />
            </g>
            <defs>
                <linearGradient id="b9a9cf51" x1="12" x2="12" y1="9.5" y2="17.5" gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
                <linearGradient id="fe1ac347" x1="15" x2="14.5" y1="10.5" y2="17.5" gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
                <linearGradient id="a5290a55" x1="9.5" x2="10" y1="10" y2="17.5" gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
